import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=6e93b0b0&"
import script from "./coming-soon.vue?vue&type=script&lang=js&"
export * from "./coming-soon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports